/**
 * Resolve admin-picked featured products against the live catalog.
 * @param {Array<{category?: string, id?: string}>} allProducts
 * @param {Array<{category_slug?: string, product_id?: string, category?: string, id?: string}>} picks
 * @param {number} [fallbackCount=8]
 */
export function resolveFeaturedProducts(allProducts, picks, fallbackCount = 8) {
  const list = Array.isArray(picks) ? picks : [];
  if (list.length === 0) {
    return [...allProducts].filter((p) => p.image).slice(0, fallbackCount);
  }
  const map = new Map();
  for (const p of allProducts) {
    if (!p?.category || p.id == null) continue;
    map.set(`${p.category}:${String(p.id)}`, p);
  }
  const resolved = [];
  for (const pick of list) {
    const cat = String(pick.category_slug || pick.category || '').trim();
    const id = String(pick.product_id ?? pick.id ?? '').trim();
    if (!cat || !id) continue;
    const product = map.get(`${cat}:${id}`);
    if (product) resolved.push(product);
  }
  if (resolved.length > 0) return resolved.slice(0, 8);
  return [...allProducts].filter((p) => p.image).slice(0, fallbackCount);
}
